export const MODE = {
  CLIENT: 'Client',
  AP: 'AP',
};

export const MODE_DROP_DOWN_OPTIONS = [
  { label: 'Client', value: 'Client' },
  { label: 'AP', value: 'AP' },
];

export const AP_SECURITY_OPTIONS = [
  { label: 'None', value: 'None' },
  { label: 'WPA2-PSK [AES]', value: 'WPA' },
  { label: 'WPA-PSK [TKIP] + WPA2-PSK [AES]', value: 'WPA/TKIP' },
];

export const CLIENT_SECURITY_OPTIONS = [
  { label: 'None', value: 'None' },
  { label: 'WPA2-PSK [AES]', value: 'WPA' },
  { label: 'WPA-PSK [TKIP] + WPA2-PSK [AES]', value: 'WPA' },
];

export const DEFAULT_MODE_DROP_DOWN_OPTION = { label: 'Client', value: 'Client' };

export const DEFAULT_SEC_DROP_DOWN_OPTION = { label: 'None', value: 'None' };

export const CLIENT_MODE_SELECTED = { label: 'Client', value: 'Client' };

export const AP_MODE_SELECTED = { label: 'AP', value: 'AP' };

export const STATUS = {
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
};

export const UNKNOWN_ERROR = 'Something went wrong';

export const INVALID_VPN = 'Invalid Vpn Address for this feature';

export const SEC_NONE = 'None';

export const WIFI_STATUS_SUCCESS = 'Wifi Status has been fetched Successfully';
export const ENABLE_WIFI_SUCCESS = 'Wifi Network has been enabled';
export const DISABLE_WIFI_SUCCESS = 'Wifi Network has been disabled';

export const DROP_DOWN_TYPE = {
  SEC_MODE: 'Sec_Mode',
  MODE: 'Mode',
};
